import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { BackofficeUnansweredTopicConversationsResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Response = DataResponse<
  z.infer<typeof BackofficeUnansweredTopicConversationsResponseDataSchema>
>

export const getBackofficeTopicConversationsQuery = (topicId: string) =>
  queryOptions({
    queryKey: ["backofficeTopicConversations", topicId],
    retry: (failureCount, error) => {
      if (axios.isAxiosError(error) && error.response?.status === 404) return false
      return failureCount < 2
    },
    queryFn: async ({ signal }) => {
      const { data } = await axios.get<Response>(
        `/backoffice/knowledge/unanswered-topics/${topicId}/conversations`,
        { signal },
      )
      return data.data
    },
  })
